import { Locale } from '~/types/locale';
import { RecurlyPlanCode } from '~/types/plan';

export type PlanFeatures = Record<Locale, Record<RecurlyPlanCode, string[]>>;
// TODO merge these features into plans.ts
export const planFeatures = {
  au: {
    essential_annual: ['Unlimited Downloads', "PDF's only"],
    plus_annual: [
      'Unlimited Downloads',
      'Interactive, customisable and editable formats',
      'Theme packs, Lesson and Unit plans',
    ],
  },
  us: {
    plus_monthly: ['Limited Downloads', 'Get a taste of Teach Starter'],
    plus_annual: [
      'Unlimited Downloads',
      'Interactive, customizable and editable formats',
      'Theme packs, Lesson and Unit plans',
      'Save $39 per year',
    ],
  },
  gb: {
    essential_annual: ['Unlimited Downloads', "PDF's only"],
    plus_annual: [
      'Unlimited Downloads',
      'Interactive, customisable and editable formats',
      'Theme packs, Lesson and Unit plans',
    ],
  },
};
